import { getTabIndex } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import { pushClickToDL, TabsDLClick } from '../ComplexTabsList.datalayer';

enum Selectors {
  // Target
  CTA = 'a',
  Tab = '.gtm-tab',
  // Content
  CTAheadline = '[role="tabpanel"]:not([hidden]) .gtm-headline',
  TabHeadline = '.gtm-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.Tab, Selectors.CTA]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const isTab = target?.classList.contains(Selectors.Tab.replace('.', ''));

  if (isTab) {
    const headlineId = target?.getAttribute('aria-controls')?.replace('-top', '') || '';
    const documentHeadline =
      componentRef?.current?.querySelector(`#${headlineId} ${Selectors.TabHeadline}`)
        ?.textContent || '';
    const tabLabel = target?.textContent || '';

    return {
      event: 'clickTab',
      eventCategory: 'Complex Tab',
      ...(!!documentHeadline && { documentHeadline }),
      ...(!!tabLabel && { tabLabel }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.CTAheadline)?.textContent || '';

  // Scroll
  return {
    event: 'clickCTA',
    eventCategory: 'Complex Tab',
    documentHeadline,
    ...(variantName && { variant_name: variantName }),
  };
};

export const onDatalayerTabClick = ({
  componentRef,
  target,
}: OnDatalayerProps): TabsDLClick | undefined => {
  if (!target || !componentRef?.current) {
    return undefined;
  }

  const tabElement = target.closest('[role=tab]') || target.closest('[role=tabpanel]');
  if (!tabElement) {
    return undefined;
  }

  const tabIndex = getTabIndex(tabElement.id);
  const tabPanelSelector = `#horizontal-tabpanel-${tabIndex} ${Selectors.TabHeadline}`;
  const headlineElement = componentRef.current.querySelector(tabPanelSelector);
  const title = headlineElement?.firstElementChild?.textContent || '';

  return pushClickToDL({ title, target });
};
